import Vue from 'vue'
import App from '@/App.vue'
import store from '@/store'

import svgIcon from '@/components/svgIcon.vue';
import AsyncComputed from 'vue-async-computed';


Vue.component('svgIcon', svgIcon);
Vue.use(AsyncComputed);

Vue.config.productionTip = false;

new Vue({
  store,
  render: h => h(App)
}).$mount('#app');
